import { render, staticRenderFns } from "./sliderMobileBig.vue?vue&type=template&id=70879644&scoped=true&"
import script from "./sliderMobileBig.vue?vue&type=script&lang=js&"
export * from "./sliderMobileBig.vue?vue&type=script&lang=js&"
import style0 from "./sliderMobileBig.vue?vue&type=style&index=0&id=70879644&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70879644",
  null
  
)

export default component.exports